import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import DescriptionIcon from "@material-ui/icons/Description";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _BondsListTable, _InfoTabs } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form";
import useTable from "../hooks/Table";

interface IRouteParam {
    ID_Anag: string;
    ID_FideAffidamento: string;
}

export const _BondsList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag, ID_FideAffidamento = "" } = useParams<IRouteParam>();
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({
        ID_Polizza: "",
        Polizza: "",
        DataEffetto: "",
        DataFine: "",
        ID_TipoProdotto: "",
        ID_TipoPolizzaStato: "",
        ID_FideAffidamento: ID_FideAffidamento
    });
    const { Data, Options, IsLoading } = useTable(`/api/Polizza/Ricerca?ID_Anag=${ID_Anag}`, FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("PolizzaController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Affidamento", ID_MenuMain: 24, VariabiliMenu: { ["{ID_FideAffidamento}"]: ID_FideAffidamento } });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={DescriptionIcon} Title="PolizzePreventivi">
                    {Glob.AzioneAbilitata("PolizzaController", Glob.Scrittura) && (
                        <NavLink to={`/anagrafica/${ID_Anag}/FideAffidamento/${ID_FideAffidamento}/FidePolizza/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoTabs ShowChartsTab ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} />
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <form noValidate autoComplete="off">
                                        <Grid container spacing={4}>
                                            <Grid item xs={6} md={2}>
                                                <TextField
                                                    fullWidth
                                                    id="ID_Polizza"
                                                    label={Trad.Trad("ID")}
                                                    value={FormData.ID_Polizza}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={2}>
                                                <TextField
                                                    fullWidth
                                                    id="Polizza"
                                                    label={Trad.Trad("Numero Polizza")}
                                                    value={FormData.Polizza}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={2}>
                                                <_DateField
                                                    Value={FormData.DataEffetto || ""}
                                                    Name="DataEffetto"
                                                    Label="Data effetto"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    required={ false}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={2}>
                                                <_DateField
                                                    Value={FormData.DataFine || ""}
                                                    Name="DataFine"
                                                    Label="Data fine"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    required={false}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={4}>
                                                <_Autocomplete
                                                    SearchInput
                                                    Value={FormData.ID_TipoProdotto}
                                                    Name="ID_TipoProdotto"
                                                    Label="TipoProdotto"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url={`/api/Tipi/Tipo?tabella=TipiProdotti&campo=TipoProdotto&parametri=${FormData.ID_TipoRamo}`}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={4}>
                                                <_Autocomplete
                                                    SearchInput
                                                    Value={FormData.ID_TipoPolizzaStato}
                                                    Name="ID_TipoPolizzaStato"
                                                    Label="Stato"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=PolizzaStato"
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid>
                                            <Grid item md={1}>
                                                <_Button
                                                    Attivo={!IsLoading}
                                                    Testo={Trad.Trad("Cerca")}
                                                    OnClick={() => {
                                                        Options.onChangePage(0);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                    <_BondsListTable ID_Anag={ID_Anag} ID_FideAffidamento={ID_FideAffidamento} Data={Data} IsLoading={IsLoading} Options={Options} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/BondsList.tsx